import React, { useMemo } from 'react';

import { ZoomInIcon } from '@vlabs/icons';
import { ButtonWithPermissions } from '@vlabs/monokit/shared/ui/button-with-permissions';
import { ButtonScrimGroup, Control } from '@vlabs/uikit';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';

import { permissions } from '@vlabs/shared/config';
import { useImageCheck } from '@vlabs/shared/hooks';

export function FaceAction({
  imageUrl = undefined,
}) {
  const { t } = useTranslation();
  const url = useMemo(() => ({ avatar: imageUrl }), [imageUrl]);
  const error = useImageCheck(url);

  const isAvatarDisabled = !imageUrl || error.avatar;

  return (
    <ButtonScrimGroup childrenAs={ButtonWithPermissions}>
      <Control.IconButton
        as={imageUrl ? 'a' : 'div'}
        disabled={isAvatarDisabled}
        href={imageUrl}
        icon={<ZoomInIcon />}
        permissions={{ rules: [permissions.faceSample.view] }}
        round
        title={t('view_full_size')}
        variant="dimmed"
      />
    </ButtonScrimGroup>
  );
}

FaceAction.propTypes = {
  imageUrl: PropTypes.string,
};
